import {currentFilledStep, StepState} from '../step-focus/step-state.model';

export type StepMenuMessage = {
    key: string;
    params: string[];
};

export type StepMenuLimit = {
    headline: StepMenuMessage;
    details: ReadonlyArray<StepMenuMessage>;
    adviceKeys: ReadonlyArray<string>;
};

export type StepMenuItem = {
    id: string;
    titleKey: string;
    stepNumber: number;
    limit: StepMenuLimit | null;
    state: StepState;
};

export function stepMenuItems(
    steps: ReadonlyArray<{id: string; titleKey: string}>,
    limits: ReadonlyMap<string, StepMenuLimit>,
    states: ReadonlyMap<string, StepState>,
): StepMenuItem[] {
    return steps.map((step, index) => ({
        id: step.id,
        titleKey: step.titleKey,
        stepNumber: index + 1,
        limit: limits.get(step.id) ?? null,
        state: states.get(step.id) ?? currentFilledStep,
    }));
}

export function currentStepId(
    trackedId: string | null,
    stepIds: ReadonlyArray<string>,
): string | null {
    return trackedId !== null && stepIds.includes(trackedId) ? trackedId : (stepIds.at(0) ?? null);
}
